"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var sodium = require("libsodium-wrappers-sumo");
var ClassUtil_1 = require("../util/ClassUtil");
var IdentityKey_1 = require("./IdentityKey");
var PreKeyAuth_1 = require("./PreKeyAuth");
var PublicKey_1 = require("./PublicKey");
var PreKeyBundle = (function () {
    function PreKeyBundle() {
        this.version = -1;
        this.prekey_id = -1;
        this.public_key = new PublicKey_1.default();
        this.identity_key = new IdentityKey_1.default();
        this.signature = null;
    }
    PreKeyBundle.new = function (public_identity_key, prekey) {
        var bundle = ClassUtil_1.default.new_instance(PreKeyBundle);
        bundle.version = 1;
        bundle.prekey_id = prekey.key_id;
        bundle.public_key = prekey.key_pair.public_key;
        bundle.identity_key = public_identity_key;
        bundle.signature = null;
        return bundle;
    };
    PreKeyBundle.signed = function (identity_pair, prekey) {
        var ratchet_key = prekey.key_pair.public_key;
        var signature = identity_pair.secret_key.sign(ratchet_key.pub_edward);
        var bundle = ClassUtil_1.default.new_instance(PreKeyBundle);
        bundle.version = 1;
        bundle.prekey_id = prekey.key_id;
        bundle.public_key = ratchet_key;
        bundle.identity_key = identity_pair.public_key;
        bundle.signature = signature;
        return bundle;
    };
    PreKeyBundle.prototype.verify = function () {
        if (!this.signature) {
            return PreKeyAuth_1.default.UNKNOWN;
        }
        if (this.identity_key.public_key.verify(this.signature, this.public_key.pub_edward)) {
            return PreKeyAuth_1.default.VALID;
        }
        return PreKeyAuth_1.default.INVALID;
    };
    PreKeyBundle.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        this.encode(encoder);
        return encoder.get_buffer();
    };
    PreKeyBundle.prototype.serialised_json = function () {
        return {
            id: this.prekey_id,
            key: sodium.to_base64(new Uint8Array(this.serialise()), sodium.base64_variants.ORIGINAL),
        };
    };
    PreKeyBundle.deserialise = function (buf) {
        return PreKeyBundle.decode(new CBOR.Decoder(buf));
    };
    PreKeyBundle.prototype.encode = function (encoder) {
        encoder.object(5);
        encoder.u8(0);
        encoder.u8(this.version);
        encoder.u8(1);
        encoder.u16(this.prekey_id);
        encoder.u8(2);
        this.public_key.encode(encoder);
        encoder.u8(3);
        this.identity_key.encode(encoder);
        encoder.u8(4);
        if (!this.signature) {
            return encoder.null();
        }
        return encoder.bytes(this.signature);
    };
    PreKeyBundle.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(PreKeyBundle);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.version = decoder.u8();
                    break;
                case 1:
                    self.prekey_id = decoder.u16();
                    break;
                case 2:
                    self.public_key = PublicKey_1.default.decode(decoder);
                    break;
                case 3:
                    self.identity_key = IdentityKey_1.default.decode(decoder);
                    break;
                case 4:
                    self.signature = decoder.optional(function () { return new Uint8Array(decoder.bytes()); });
                    break;
                default:
                    decoder.skip();
            }
        }
        return self;
    };
    return PreKeyBundle;
}());
exports.default = PreKeyBundle;
//# sourceMappingURL=PreKeyBundle.js.map


//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/PreKeyBundle.js
// module id = 108
// module chunks = 0 1